import ThemeModal from "components/Common/ThemeModal";
import { Row, Col, Table, Button } from "reactstrap";
import PettyCashBillPay from "./PettyCashBillPay";
import React from "react";

const PettyCashBillView = ({ modal, toggleModal, bill }) => {
  const [payModal, setPayModal] = React.useState(false);
  const togglePayModal = () => setPayModal(!payModal);

  if (!bill) return null;

  return (
    <>
      <ThemeModal isOpen={modal} toggle={toggleModal} title={`Bill ${bill.bill_no}`}>
        <Row>
          <Col sm={6}><b>Bill Date:</b> {bill.bill_date}</Col>
          <Col sm={6}><b>Status:</b> {bill.status}</Col>
          <Col sm={6}><b>Vehicle:</b> {bill.vehicle?.stock_id}</Col>
          <Col sm={6}><b>Submitted By:</b> {bill.submitted_by_name}</Col>
        </Row>

        <hr />
        <h6>Items</h6>
        <Table size="sm">
          <thead>
            <tr><th>Payment For</th><th>Description</th><th>Amount</th></tr>
          </thead>
          <tbody>
            {bill.items?.map((i, idx) => <tr key={idx}>
              <td>{i.payment_for_name}</td>
              <td>{i.description}</td>
              <td>{i.amount}</td>
            </tr>)}
          </tbody>
        </Table>

        <h6>Payments</h6>
        <Table size="sm">
          <thead>
            <tr><th>Date</th><th>Amount</th><th>Mode</th></tr>
          </thead>
          <tbody>
            {bill.payments?.map((p, idx) => <tr key={idx}>
              <td>{p.payment_date}</td>
              <td>{p.amount}</td>
              <td>{p.payment_mode_name}</td>
            </tr>)}
          </tbody>
        </Table>

        {bill.status !== "paid" && <Button color="success" onClick={togglePayModal}>Pay Bill</Button>}
      </ThemeModal>

      <PettyCashBillPay modal={payModal} toggleModal={togglePayModal} bill={bill} />
    </>
  );
};

export default PettyCashBillView;